var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#313840",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2 18.315v3.777h24.698l-.018-3.725-2.089-6.003a.58.58 0 0 1-.033-.193s-.038-5.292-.038-5.823l-20.288.045v5.717a.582.582 0 0 1-.036.207L5.2 18.315zm25.317 8.067a.598.598 0 0 1-.599-.597l-.013-2.493-24.706.001v2.434a.6.6 0 0 1-1.199 0V18.21c0-.07.012-.14.036-.207l2.197-5.998v-5.85c0-.466.327-.962.936-.962h20.592c.59.03 1.158.435 1.158 1.156 0 .487.032 4.987.038 5.715l2.09 6.004a.582.582 0 0 1 .032.194l.022 4.351a.666.666 0 0 1 .005.078l.011 3.09a.599.599 0 0 1-.597.602h-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.639 12.71h21.71v-1.2H6.639zM4.538 18.892h25.978v-1.2H4.538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.94 12.08l-.002-1.778a1 1 0 0 0-.333-.75c-.623-.579-1.946-.638-2.401-.618l-4.352.02c-1.016 0-1.75.233-2.123.675-.38.447-.305 1.008-.304 1.014l-1.183.198c-.008-.045-.175-1.106.57-1.988.618-.73 1.64-1.1 3.037-1.1l4.32-.018c.194-.012 2.15-.085 3.25.935.455.421.704.98.717 1.618l.002 1.791-1.199.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.22 12.049l-1.198-.001.002-1.778c.014-.652.262-1.211.717-1.632 1.099-1.018 3.059-.945 3.28-.933l4.293.017c1.394 0 2.416.37 3.033 1.1.746.882.579 1.943.57 1.987l-1.182-.198.59.099-.591-.093c.003-.023.078-.58-.312-1.03-.377-.435-1.106-.664-2.111-.664l-4.325-.02c-.481-.021-1.813.043-2.432.617-.22.203-.323.446-.331.764l-.002 1.765z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.131f36a7291e495c664e5ecd28d105cf.svg";
export { ForwardRef as ReactComponent };